import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

// Fullscreen slideshow for condolence photos with prev/next + close.
export const PhotoLightbox = ({ photos, index, onClose, onIndex }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowRight") onIndex((index + 1) % photos.length);
      else if (e.key === "ArrowLeft") onIndex((index - 1 + photos.length) % photos.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, photos, onClose, onIndex]);

  if (!photos || !photos.length) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95" onClick={onClose} data-testid="photo-lightbox">
      <button onClick={onClose} className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white transition-colors hover:bg-white/25" data-testid="lightbox-close-btn" aria-label="Fermer">
        <X size={22} />
      </button>
      {photos.length > 1 && (
        <>
          <button onClick={(e) => { e.stopPropagation(); onIndex((index - 1 + photos.length) % photos.length); }} className="absolute left-3 rounded-full bg-white/10 p-2 text-white transition-colors hover:bg-white/25" data-testid="lightbox-prev-btn" aria-label="Précédent"><ChevronLeft size={26} /></button>
          <button onClick={(e) => { e.stopPropagation(); onIndex((index + 1) % photos.length); }} className="absolute right-3 rounded-full bg-white/10 p-2 text-white transition-colors hover:bg-white/25" data-testid="lightbox-next-btn" aria-label="Suivant"><ChevronRight size={26} /></button>
        </>
      )}
      <img src={photos[index]} alt="" className="max-h-[85vh] max-w-[92vw] rounded-lg object-contain" onClick={(e) => e.stopPropagation()} data-testid="lightbox-image" />
      {photos.length > 1 && (
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-white/10 px-3 py-1 text-sm text-white" data-testid="lightbox-counter">{index + 1} / {photos.length}</div>
      )}
    </div>
  );
};
